import { createContext, useContext, useMemo, useState } from "react";

const SelectedCollectedOrderDataValueContext = createContext();
const SelectedCollectedOrderDataActionsContext = createContext();

export function SelectedCollectedOrderDataContextProvider({ children }) {
    const [selectedCollectedOrderData, setSelectedCollectedOrderData] = useState(null);

    const selectedCollectedOrderDataActions = useMemo(
        () => {
            return {
                onSet(newValue) {
                    setSelectedCollectedOrderData(newValue);
                },
                setValue: setSelectedCollectedOrderData
            }
        },
        []
    )

    return (
        <>
            <SelectedCollectedOrderDataActionsContext.Provider value={{ selectedCollectedOrderData: selectedCollectedOrderDataActions }}>
                <SelectedCollectedOrderDataValueContext.Provider value={{ selectedCollectedOrderData }}>
                    {children}
                </SelectedCollectedOrderDataValueContext.Provider>
            </SelectedCollectedOrderDataActionsContext.Provider>
        </>
    );
}

export function useSelectedCollectedOrderDataValueContextHook(props) {
    const value = useContext(SelectedCollectedOrderDataValueContext);

    if (value === undefined) {
        throw new Error('useSelectedCollectedOrderDataValueContextHook should be used within SelectedCollectedOrderDataValueContext');
    }

    return {
        selectedCollectedOrderData: value.selectedCollectedOrderData
    };
}

export function useSelectedCollectedOrderDataActionsContextHook(props) {
    const value = useContext(SelectedCollectedOrderDataActionsContext);

    if (value === undefined) {
        throw new Error('useSelectedCollectedOrderDataActionsContextHook should be used within SelectedCollectedOrderDataActionsContext');
    }

    return {
        selectedCollectedOrderData: {
            onSet: value.selectedCollectedOrderData.onSet,
            setValue: value.selectedCollectedOrderData.setValue
        }
    };
}